import React from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
// import "./WinnersLand.css";

import { useTheme, useCountUp } from "../WinnerLand/useTheme";

// function WinnersCities({
//   eyebrow,
//   title,
//   description,
//   cities,
// }) {
//   return (
//     <section className="ws-cities">
//       <div className="ws-cities-head">
//         <div>
//           <span className="ws-section-eyebrow">{eyebrow}</span>
//           <h2 className="ws-section-heading">{title}</h2>
//         </div>
//         <p>{description}</p>
//       </div>

//       <div className="ws-cities-grid">
//         {cities.map((c, i) => (
//           <article className="ws-city-card" key={c.name + i}>
//             <div className="ws-city-img">
//               <img
//                 src={c.img}
//                 alt={c.name}
//                 loading="lazy"
//                 width={640}
//                 height={840}
//               />
//             </div>

//             <span className="ws-city-badge">
//               <MapPin size={12} />
//               {c.tag}
//             </span>

//             <div className="ws-city-body">
//               <h3>{c.name}</h3>

//               <div className="ws-city-meta">
//                 <div>
//                   <span className="ws-city-meta-num">{c.count}</span>
//                   properties
//                 </div>

//                 <div className="ws-city-arrow">
//                   <ArrowUpRight size={16} />
//                 </div>
//               </div>
//             </div>
//           </article>
//         ))}
//       </div>
//     </section>
//   );
// }

// export default WinnersCities;

export function WinnersCities({
  eyebrow,
  title,
  description,
  cities = [],
}) {
  return (
    <section className="ws-cities">
      <div className="ws-cities-head">
        <div>
          <span className="ws-section-eyebrow">{eyebrow}</span>
          <h2 className="ws-section-heading">{title}</h2>
        </div>
        <p>{description}</p>
      </div>

      <div className="ws-cities-grid">
        {cities.map((c, i) => (
          <article className="ws-city-card" key={c.name + i}>
            <div className="ws-city-img">
              <img src={c.img} alt={c.name} loading="lazy" width={640} height={840} />
            </div>
            <span className="ws-city-badge"><MapPin size={12} /> {c.tag}</span>
            <div className="ws-city-body">
              <h3>{c.name}</h3>
              <div className="ws-city-meta">
                <div><span className="ws-city-meta-num">{c.count}</span> properties</div>
                <div className="ws-city-arrow"><ArrowUpRight size={16} /></div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}